// The one country list, and the one supported market.
//
// This existed only inside AuditIntake.jsx until the paid product became
// Australia-only. Checkout now has to ask the same question BEFORE the card is
// charged, and two copies of a list that decides what may be sold is how the
// form and the till come to disagree about which countries exist.
//
// SUPPORTED_COUNTRIES mirrors backend/market.py's SUPPORTED_CLIENT_COUNTRIES.
// The backend is authoritative and refuses the checkout on its own; this is
// here so the interface can explain the boundary before the buyer hits it,
// never so the frontend can decide it.
export const COUNTRIES = [
  ["AU", "Australia"],
  ["NZ", "New Zealand"],
  ["GB", "United Kingdom"],
  ["US", "United States"],
  ["CA", "Canada"],
  ["SG", "Singapore"],
  ["IN", "India"],
  ["OT", "Somewhere else"],
];

export const SUPPORTED_COUNTRIES = ["AU"];

export const isSupportedMarket = (code) =>
  SUPPORTED_COUNTRIES.includes(String(code || "").trim().toUpperCase());
